/* src/app/private/components/leads/delete-lead-space/delete-lead-space.component.scss */
/*# sourceMappingURL=delete-lead-space.component.css.map */
